import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import * as yup from 'yup';

const MailSchema = yup.object().shape({
  assunto: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('o assunto')),
  emails: yup.array().of(
    yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('o email'))
      .email('E-mail inválido')
  ),
});

export default MailSchema;
